// src/services/openaiService.js
import { supabase } from "../lib/supabase";

const FLOORPLAN_FUNCTION_NAME = "analyze-floorplan";
const QUALIFY_FUNCTION_NAME = "qualify-lead"; // <-- cambia si tu edge function se llama diferente

async function readEdgeErrorBody(err) {
  const res = err?.context;
  if (res && typeof res.text === "function") {
    try {
      const txt = await res.text();
      return txt;
    } catch (_) {}
  }
  return err?.message || String(err);
}

function getSupabaseEdgeHeaders() {
  const anonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;
  return {
    "Content-Type": "application/json",
    ...(anonKey
      ? {
          apikey: anonKey,
          Authorization: `Bearer ${anonKey}`,
        }
      : {}),
  };
}

export const openaiService = {
  async analyzePDFFloorPlan({ pdfBase64, imageDataUrl }) {
    const hasPdf = typeof pdfBase64 === "string" && pdfBase64.length > 1000;
    const hasImg = typeof imageDataUrl === "string" && imageDataUrl.length > 1000;

    if (!hasPdf && !hasImg) {
      throw new Error("No se recibió pdfBase64 o imageDataUrl válido para analizar.");
    }

    const body = hasPdf ? { pdfBase64 } : { imageDataUrl };

    const { data, error } = await supabase.functions.invoke(FLOORPLAN_FUNCTION_NAME, {
      body,
      headers: getSupabaseEdgeHeaders(),
    });

    if (error) {
      const bodyText = await readEdgeErrorBody(error);
      console.error("Supabase invoke error:", error);
      console.error("Edge error body:", bodyText);
      throw new Error(`Edge Error (${error?.context?.status || "?"}): ${bodyText}`);
    }

    if (!data) throw new Error("La función Edge no devolvió data.");
    if (data?.error) throw new Error(typeof data.error === "string" ? data.error : JSON.stringify(data.error));
    if (!Array.isArray(data?.lots)) throw new Error("La IA no devolvió el formato esperado (lots).");

    return data;
  },

  // ✅ NUEVO: calificar lead con IA
  async qualifyLead(leadData) {
    // Normaliza input mínimo para la IA
    const payload = {
      nombre: leadData?.nombre || "",
      email: leadData?.email || "",
      telefono: leadData?.telefono || "",
      fuente: leadData?.fuente || "landing_page",
      presupuesto: leadData?.presupuesto ?? null,
      proyectoInteres: leadData?.proyectoInteres || leadData?.proyecto_interes || "",
      mensaje: leadData?.mensaje || leadData?.message || "",
      timeframe: leadData?.timeframe || leadData?.plazo || "",
    };

    const { data, error } = await supabase.functions.invoke(QUALIFY_FUNCTION_NAME, {
      body: { lead: payload },
      headers: getSupabaseEdgeHeaders(),
    });

    if (error) {
      const bodyText = await readEdgeErrorBody(error);
      console.error("Supabase invoke error (qualifyLead):", error);
      console.error("Edge error body (qualifyLead):", bodyText);
      throw new Error(`Edge Error qualifyLead (${error?.context?.status || "?"}): ${bodyText}`);
    }

    if (!data) throw new Error("La función Edge (qualifyLead) no devolvió data.");
    if (data?.error) throw new Error(typeof data.error === "string" ? data.error : JSON.stringify(data.error));

    // Devuelve tal cual lo que venga, pero con defaults seguros
    return {
      qualificationScore: typeof data?.qualificationScore === "number" ? data.qualificationScore : 50,
      followUpPriority: data?.followUpPriority || "medium",
      suggestedProjects: Array.isArray(data?.suggestedProjects) ? data.suggestedProjects : ["Residencial 3 Volcanes"],
      recommendedActions: Array.isArray(data?.recommendedActions) ? data.recommendedActions : ["Contactar al lead y validar presupuesto."],
      ...data,
    };
  },
};

export default openaiService;
